import { render, staticRenderFns } from "./DocenteEditarDisponibilidad.vue?vue&type=template&id=14841c30&"
import script from "./DocenteEditarDisponibilidad.vue?vue&type=script&lang=js&"
export * from "./DocenteEditarDisponibilidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports